
export default class Session{

  constructor(){
    this.id = null;
    this.code = null;
    this.convocatory = null;
    this.route = null;
    this.group = null;
    this.date = null;
    this.survey = null;
  }

  setDataAsisstance(data){
    this.id = data.idsesion;
    this.convocatory = data.convocatoria;
    this.route = data.ruta;
    this.group = data.grupo;
    this.date = data.fecha;
    this.survey = data.encuesta;
  }

}